import type { ICampaign } from "../../../../types/models/campaign.models.types";
import { usePutHttp } from "../../http.hook";

interface IBody {
  dmsCampaignId: string | null;
}

interface IResponse {
  campaign: ICampaign;
}

export function useLinkWithDmsCampaignAdminHttp() {
  return usePutHttp<IBody, IResponse>({
    path: "/admin/campaigns/:campaignId/link-dms-campaign",
  });
}
